export default "__VITE_ASSET__CsjI6hIc__"